import { Login, Logout, Reset, UpdateTokens, HelloLogin } from './../actions/auth.action';
import { AuthService } from './../services/auth.service';
import { State, Selector, StateContext, Action } from '@ngxs/store';
import { tap, take } from 'rxjs/operators';
import { User } from '../models/user';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { Injectable, NgZone } from '@angular/core';
export class AuthStateModel {
  user?: User;
}
@State<AuthStateModel>({
  name: 'auth'
})
@Injectable()
export class AuthState {
  @Selector()
  static token(state: AuthStateModel) {
    return state.user.accessToken;
  }
  @Selector()
  static refreshToken(state: AuthStateModel) {
    return state.user.refreshToken;
  }

  @Selector()
  static currentUser(state: AuthStateModel) {
    return state.user;
  }
  @Selector()
  static loggedIn(state: AuthStateModel): boolean {
    return (
      state.user.accessToken !== undefined && state.user.accessToken.length > 0
    );
  }

  constructor(
    private authService: AuthService,
    private router: Router,
    private zone: NgZone
  ) {}
  @Action(Login)
  login({ setState }: StateContext<AuthStateModel>, { payload }: Login) {
    return this.authService.login(payload.username, payload.password).pipe(
      tap(result => {
        setState({
          user: {
            accessToken: result.access_token,
            username: payload.username,
            refreshToken: result.refresh_token
          }
        });
      })
    );
  }

  @Action(HelloLogin)
  helloLogin({ setState }: StateContext<AuthStateModel>, { payload }: HelloLogin) {
    return this.authService.refreshAccessToken( payload.refreshToken ).pipe(
      tap(result => {
        console.log( 'tap');
        setState({
          user: {
            accessToken: result.access_token,
            refreshToken: result.refresh_token
          }
        });
      })
    );
  }


  @Action(Logout)
  logout({ payload }: Logout) {
    this.zone.run(() =>
      this.authService
        .logout(payload)
        .pipe(tap(() => this.router.navigate(['/login'])))
        .subscribe()
    );
  }
  @Action(Reset)
  reset({ setState }: StateContext<AuthStateModel>) {
    setState({});
  }

  @Action(UpdateTokens)
  updateTokens(
    { getState, patchState }: StateContext<AuthStateModel>,
    { payload }: UpdateTokens
  ) {
    const state = getState();
    patchState({
      user: { ...state.user, ...payload }
    });

    return of(true);
  }
}
